import * as React from "react";
import { Pane, TextInput, Text } from "evergreen-ui";
export function QuantitySelect(props) {
    // const changeQty = (v) => {
    //     console.log(v, props.order.qty);
    //     if (props.order.qty + v > 0){
    //         let o = props.order;
    //         o.qty += v;
    //         props.setOrder({...o});
    //     }
    // }
    // let o = props.order;
    // o.qty = parseInt((e.target.value > 0 ? e.target.value : 1) || 1);
    // props.setOrder({...o});
    return (React.createElement(Pane, { display: "flex", padding: 8, marginBottom: 16, borderRadius: 3, style: {
            justifyContent: "center",
            display: "Flex",
            alignContent: "center",
            alignItems: "center",
        } },
        props.caption && (React.createElement(Pane, { flex: 1, marginRight: 16, display: "flex", style: { textAlign: "right", display: "block" } },
            React.createElement(Text, null, props.caption))),
        React.createElement(Pane, { display: "flex", justifyContent: "center", flex: "1" },
            React.createElement(TextInput, { role: "TheQtyValue", style: { textAlign: "center" }, width: "100%", type: "number", id: "qty", min: 1, value: props.qty, onChange: (e) => {
                    props.onQtyChanged(parseInt((e.target.value > 0 ? e.target.value : 1) || 1));
                } }))));
}
